/* eslint-disable prefer-regex-literals */

// https://stackoverflow.com/a/18418386/10806944
export const simpleStringMatcher = (word: string, search: string): boolean => {
  if (typeof search !== "string" || typeof word !== "string") {
    return false;
  }

  word = word.toLowerCase();
  search = search.toLowerCase();

  return word.includes(search);
};
